import authHandler from './api/auth-handler';

type AuthorizationContext = {
  contextId: number | null | undefined;
  expiryTimeToLive: string | number | null;
} & CMxCommonApp.BearerToken;

const _Authorization: AuthorizationContext = {
  token: null,
  contextId: null,
  expiryTimeToLive: null
};

const getAuthorization = () => {
  return _Authorization;
};

const setAuthorization = (authContext: AuthorizationContext) => {
  authHandler.token = _Authorization.token = authContext.token;
  _Authorization.contextId = authContext.contextId;
};

const setContextId = (contextId: number | null) => {
  _Authorization.contextId = contextId;
};

const setToken = (token: string | null) => {
  authHandler.token = _Authorization.token = token || null;
  if (token === null) {
    setContextId(null);
  }
};

const getToken = () => {
  return authHandler.token;
};

const getContextId = () => {
  return _Authorization.contextId;
};

export {
  getContextId,
  getToken,
  setToken,
  setContextId,
  setAuthorization,
  getAuthorization
};
